/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptionsContent_item = {
    readonly leadTimeDisplay: string | null;
    readonly isCustomizable: boolean | null;
    readonly seller: {
        readonly isJewelrySeller: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_item">;
    readonly " $refType": "PdpSharedDescriptionAdditionalOptionsContent_item";
};
export type PdpSharedDescriptionAdditionalOptionsContent_item$data = PdpSharedDescriptionAdditionalOptionsContent_item;
export type PdpSharedDescriptionAdditionalOptionsContent_item$key = {
    readonly " $data"?: PdpSharedDescriptionAdditionalOptionsContent_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDescriptionAdditionalOptionsContent_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "leadTimeDisplay",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCustomizable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isJewelrySeller",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item",
      "args": null
    }
  ]
};
(node as any).hash = '5bda56f76f41757be069f9baf9e607ea';
export default node;
